import React from 'react'
import { HelpModal } from '../help/help-modal.component'

export const IdleLogoutAlert = ({modalRef}) =>
  <HelpModal innerRef={modalRef} title='Idle Logout'>
    You were logged out after 2 hours of inactivity.
  </HelpModal>